import { Components, Theme } from '@mui/material';

export const MuiCircularProgressTheme = (): Components<Theme>['MuiCircularProgress'] => {
  return {
    variants: [
      {
        props: { size: 'small' },
        style: {
          width: '18px',
          height: '18px',
        },
      },
      {
        props: { size: 'medium' },
        style: {
          width: '36px',
          height: '36px',
        },
      },
      {
        props: { size: 'large' },
        style: {
          width: '54px',
          height: '54px',
        },
      },
    ],
    styleOverrides: {
      root: {
        display: 'inline-block',
        color: 'currentColor',
      },
    },
  };
};
